import { load } from "common/loader";
import { ReesizeEventHandler } from "common/resize";
import { chatbotPaths, chatbotSoundPath } from "from-start/scene/resources";
import { loadSound } from "from-start/scene/resources/chatbotSound";
import { ChatBotContentController } from "./chatBotContent";
export async function start() {
    const resizer = new ReesizeEventHandler();
    const spinner = $("<jh-chat-bot-loading></jh-chat-bot-loading>");
    $("#resizer").append(spinner);
    let audioSrc = "";
    await load({
        onProgress: () => null,
        onComplete: () => null,
        onAudio: (src) => (audioSrc = src),
        filePaths: [...chatbotPaths, chatbotSoundPath],
    });
    const sound = await loadSound(audioSrc);
    $("jh-chat-bot-loading").remove();
    const chatBot = $(`<jh-chat-bot class="uni"></jh-chat-bot>`);
    $("#resizer").append(chatBot);
    const chatbotElem = chatBot[0];
    resizer.add(chatbotElem.onResize);
    await chatbotElem.waitFirstRender();
    sound.playLoop("chatbotBgm");
    const chatBotController = new ChatBotContentController(chatBot);
    await chatBotController.startTimer(sound);
    $("jh-chat-bot").remove();
    resizer.drop();
    // normalLetterBox();
}
//# sourceMappingURL=main.js.map